// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const resetNewTransfer = () => ({
    type: actions.RESET_NEW_TRANSFER
});




// WEBPACK FOOTER //
// ./src/product/new-transfer/action-creators/reset-new-transfer.js